import { Navigate } from '@sorare/routing';
import { ANY_SPORT_PLAY_BOARDS_ARENA_ARENAMODE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { Mode } from '#src/components/pickers/ModePicker/index.tsx';
import { useLastVisitedBoardView } from '#src/hooks/useLastVisitedBoardView.ts';
import { modeToArenaMode } from '#src/lib/gameMode.ts';

const BoardsArenaPage = () => {
  const { generateSportContextPath } = useSportContext();
  const { lastVisitedView } = useLastVisitedBoardView();

  const arenaMode = modeToArenaMode(
    lastVisitedView?.lastVisitedMode ?? Mode.ARENA_IN_SEASON
  );

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_PLAY_BOARDS_ARENA_ARENAMODE, {
        params: { arenaMode },
      })}
      replace
      keepSearchParams
    />
  );
};

export default BoardsArenaPage;
